<template>
    <div id="recently_courses_div">
        <Title class="recently_courses_course_title"
               :title="'近期好课 | '"
               :description="'最新最热的课程，期待您的关注'"
               :more="'courses'"
               :query="{'sort':'month'}"
        >
        </Title>
        <v-loader :source="index_recently_courses">
            <div class="item_card">
                <CourseCard class="recently_courses_card"
                      v-for="(data, index) in index_recently_courses "
                      :key="index"
                      :data="data"
                >

                </CourseCard>

            </div>
        </v-loader>
    </div>
</template>

<script type="text/javascript">
import Title from './sub_components/title.vue'
import Card from '../common_components/cards/lou_plus_card.vue'
import CourseCard from '../common_components/cards/course_card.vue'

import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            index_louplus: state => state.home.home_content.index_louplus.slice(0,4),
            index_recently_courses: state => state.home.home_content.index_recently_courses,
        })
    },
    components: {
      Title,
      CourseCard,
      Card
    }
}
</script>

<style type="text/css" scoped>
#recently_courses_div {
    display: flex;
    flex-direction: column;
    width: 1150px;
    margin-left: auto;
    margin-right: auto;
    padding: 30px 15px 0 0;
    background: #f7f7f7;
    margin-bottom: 30px;
}

.recently_courses_course_title {
    margin-bottom: 30px;
}

.item_card {
    display: flex;
    justify-content: space-around;
    padding: 0 15px;
}

.recently_courses_card {
    width: 25%;
    box-sizing: border-box;
    padding-right: 19px;
}

</style>
